/**
 * @generated SignedSource<<1d0fd27bf7eb6067ba681a3437f5503c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type LoginQuery$variables = Record<PropertyKey, never>;
export type LoginQuery$data = {
  readonly currentUser: {
    readonly displayName: string;
    readonly username: string;
  } | null | undefined;
};
export type LoginQuery = {
  response: LoginQuery$data;
  variables: LoginQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "currentUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "username",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "displayName",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "LoginQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "LoginQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "25bcc7d7e76a5c246c23c58f4898b1a7",
    "id": null,
    "metadata": {},
    "name": "LoginQuery",
    "operationKind": "query",
    "text": "query LoginQuery {\n  currentUser {\n    username\n    displayName\n  }\n}\n"
  }
};
})();

(node as any).hash = "16e87eea3192e86c6167e207f6c7923b";

export default node;
